import { useEffect } from 'react';
import { preloadUserCallGreeting } from './callGreeting';
/**
 * Preload the agent greeting after login (from CRM files API by account email),
 * before the softphone registers. No playback without an uploaded file.
 */
export function useCallGreetingPreload(uploadedByEmail) {
    useEffect(() => {
        const email = uploadedByEmail?.trim();
        if (!email) {
            return;
        }
        void preloadUserCallGreeting(email);
    }, [uploadedByEmail]);
}
